import { render, staticRenderFns } from "./CatalogShowMoreBtn.vue?vue&type=template&id=21eb9ef6&scoped=true&"
import script from "./CatalogShowMoreBtn.vue?vue&type=script&lang=js&"
export * from "./CatalogShowMoreBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb9ef6",
  null
  
)

export default component.exports